import { render, staticRenderFns } from "./FormRooms.vue?vue&type=template&id=34fefbf0&"
import script from "./FormRooms.vue?vue&type=script&lang=js&"
export * from "./FormRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports